import {colors} from './maps/colors';

export const rndPiNumber = () => Math.floor(Math.random() * 90000) + 10000;

export const dateToColor = date => {
    const num = new Date(date).getTime();
    return colors.COLLECTION[
    num % colors.COLLECTION.length
        ];
};

export const idToColor = id => {
    
    let res = 0;
    for (let i = 0; i < id.length; i++) {
        // if (!!parseInt(id[i])) 
        res += parseInt(id.charCodeAt(i));
    }

    return colors.COLLECTION[   
    res % colors.COLLECTION.length
        ];
};

export const userColor = circle => {
      if (circle.user_color){
 
     return `rgba(${circle.user_color[0]}, ${circle.user_color[1]}, ${circle.user_color[2]}, 1)`;
    }else{
 
 

return `#ccc`;


    }
};

export const isMobileUserAgent = () => {
    const userAgent =
        typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    return Boolean(
        userAgent.match(
            /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
        )
    );
};

export const hasRTLCharacters = text => {
    return text.match(/[\u0600-\u06FF\u0750-\u077F\u0590-\u05FF\uFE70-\uFEFF]/);
};

export const generateRandomName = (numberOfLetters = 1, numberOfNumbers = 2) => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let randomLetters = "";

    let counter = 0;
    while (counter < numberOfLetters) {
        const randomLetter = letters.charAt(Math.floor(Math.random() * letters.length));
        randomLetters += randomLetter;
        counter++;
    }

    const min = Math.pow(10, numberOfNumbers - 1);
    const max = Math.pow(10, numberOfNumbers) - 1;
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

    return randomLetters + randomNumber;
};

export const dateAgo = dateInput => {
    const now = new Date();
    const date = new Date(dateInput);
    const diffInSeconds = Math.floor((now - date) / 1000);
    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30; // Approximate
    const year = day * 365;

    if (diffInSeconds < minute) {
        return diffInSeconds + ' seconds ago';
    } else if (diffInSeconds < hour) {
        return Math.floor(diffInSeconds / minute) + ' minutes ago';
    } else if (diffInSeconds < day) {
        return Math.floor(diffInSeconds / hour) + ' hours ago';
    } else if (diffInSeconds < month) {
        return Math.floor(diffInSeconds / day) + ' days ago';
    } else if (diffInSeconds < year) {
        return Math.floor(diffInSeconds / month) + ' months ago';
    } else {
        return Math.floor(diffInSeconds / year) + ' years ago';
    }
};

export function calculateContainerHeight(originalWidth, originalHeight, containerWidth) {
    const aspectRatio = originalHeight / originalWidth;
    const containerHeight = containerWidth * aspectRatio;

    return containerHeight;
}